// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FinancialAggregates {
  margin-bottom: 1rem;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}
.FinancialAggregates__Header {
  flex-basis: 100%;
  text-align: center;
}
.FinancialAggregates__BadgeContainer {
  display: flex;
}
.FinancialAggregates__Badge {
  display: flex;
  flex-wrap: wrap;
  text-align: center;
}
.FinancialAggregates__Badge span {
  width: 100%;
}
.FinancialAggregates__Dollars {
  width: 100%;
  font-size: 2rem;
  color: #01579b;
}`, "",{"version":3,"sources":["webpack://./apps/app/src/app/views/home-list/financial-aggregates/financial-aggregates.component.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;AACF;AACE;EACE,gBAAA;EACA,kBAAA;AACJ;AAEE;EACE,aAAA;AAAJ;AAGE;EACE,aAAA;EACA,eAAA;EACA,kBAAA;AADJ;AAGI;EACE,WAAA;AADN;AAKE;EACE,WAAA;EACA,eAAA;EACA,cAAA;AAHJ","sourcesContent":[".FinancialAggregates {\n  margin-bottom: 1rem;\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n\n  &__Header {\n    flex-basis: 100%;\n    text-align: center;\n  }\n\n  &__BadgeContainer {\n    display: flex;\n  }\n\n  &__Badge {\n    display: flex;\n    flex-wrap: wrap;\n    text-align: center;\n\n    span {\n      width: 100%;\n    }\n  }\n\n  &__Dollars {\n    width: 100%;\n    font-size: 2rem;\n    color: #01579b;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
